import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreditSharedModule } from './extensions/127f7e741a0df228f390786c59b6e09930ad86e153c8c0b21ef19c2caeaef52f/credit-shared.module';



@NgModule({
    imports: [CommonModule, CreditSharedModule],
    providers: [],
})
export class SharedExtensionsModule {}
